import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-cn";
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
export default {
  name: "plan-book-list",
  components: {
    DatePicker: DatePicker
  },
  data: function data() {
    return {
      searchParams: {
        orderNo: '',
        erpId: '',
        status: 0,
        time: []
      },
      total: 20,
      planList: [],
      page: 1,
      pageSize: 10,
      // 当前页面序号起始位置
      currentIndexStart: 0,
      images: []
    };
  },
  mounted: function mounted() {
    Vue.use(Viewer);
    this.queryPlanList();
  },
  methods: {
    resetSearchParams: function resetSearchParams() {
      this.searchParams = {
        orderNo: '',
        erpId: '',
        status: 0,
        time: []
      };
    },
    openExcel: function openExcel(item) {
      window.open("https://view.officeapps.live.com/op/view.aspx?src=" + item, "_blank");
    },
    handlePageChange: function handlePageChange(val) {
      this.page = val;
      this.queryPlanList();
    },
    // 作废
    cancelPlan: function cancelPlan(planId) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var that;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = _this;
              _this.$buefy.dialog.confirm({
                message: "<span style='font-size: 16px;'>确认立即作废吗？</span>",
                confirmText: "确定",
                cancelText: "取消",
                type: "is-info",
                size: "is-small",
                onConfirm: function () {
                  var _onConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    var res;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return that.$getHttpClient().post('/pjyy-deepexi-product-center/api/v3/MyPlan/cancel?id=' + planId);
                        case 2:
                          res = _context.sent;
                          console.log('请求结果', res);
                          if (res.data.code == 200) {
                            that.$buefy.toast.open({
                              message: "作废成功",
                              type: "is-danger"
                            });
                            setTimeout(function () {
                              that.queryPlanList();
                            }, 500);
                          }
                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  function onConfirm() {
                    return _onConfirm.apply(this, arguments);
                  }
                  return onConfirm;
                }()
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    queryPlanList: function queryPlanList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var pageNum, queryParam, res, planList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              pageNum = _this2.page;
              queryParam = {
                page: pageNum,
                pageSize: _this2.pageSize,
                erpId: _this2.searchParams.erpId,
                orderNo: _this2.searchParams.orderNo
              };
              if (_this2.searchParams.time && _this2.searchParams.time.length > 0) {
                if (_this2.searchParams.time[0]) {
                  queryParam.beginTimestamp = _this2.searchParams.time[0].getTime();
                }
                if (_this2.searchParams.time[1]) {
                  queryParam.endTimestamp = _this2.searchParams.time[1].getTime();
                }
              }
              if (_this2.searchParams.status && _this2.searchParams.status > 0) {
                queryParam.status = _this2.searchParams.status;
              }
              _this2.planList = [];
              _context3.next = 7;
              return _this2.$getHttpClient().post('/pjyy-deepexi-product-center/api/v3/MyPlan/page', queryParam);
            case 7:
              res = _context3.sent;
              if (res.data.code == 200) {
                planList = res.data.data.list;
                _this2.total = res.data.data.total;
                _this2.currentIndexStart = (pageNum - 1) * _this2.pageSize;
                planList.forEach(function (planInfo) {
                  var planItem = {
                    planId: planInfo.id,
                    orderNo: planInfo.orderNo,
                    isUrge: false,
                    remarks: planInfo.remark,
                    createTime: planInfo.createTimeStr,
                    handleResult: planInfo.dealResult,
                    status: planInfo.status,
                    erpNo: planInfo.erpNo,
                    imageList: [],
                    fileList: [],
                    statusName: planInfo.statusName,
                    customerCode: planInfo.customerCode,
                    customerName: planInfo.customerName,
                    staffName: planInfo.staffName,
                    handleTime: planInfo.dealTimeStr,
                    deviceType: planInfo.deviceType
                  };
                  if (planInfo.deviceType == 1) {
                    planItem.deviceTypeStr = 'PC商城';
                  } else if (planInfo.deviceType == 2) {
                    planItem.deviceTypeStr = 'Android';
                  } else if (planInfo.deviceType == 3) {
                    planItem.deviceTypeStr = 'IOS';
                  } else if (planInfo.deviceType == 4) {
                    planItem.deviceTypeStr = '小程序';
                  } else {
                    planItem.deviceTypeStr = '';
                  }
                  if (planInfo.lstFile.length > 0) {
                    planInfo.lstFile.forEach(function (lstFle) {
                      if (lstFle.fileType === 1) {
                        // 图片
                        planItem.imageList.push(lstFle.fileUrl);
                      } else {
                        // 文件

                        planItem.fileList.push(lstFle.fileUrl);
                      }
                    });
                  }
                  _this2.planList.push(planItem);
                });
              }
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};